'use client';

import { AlertUsers } from '@/components/AlertUsers';
import { ReplaceVirtuallyForm } from './components/ReplaceVirtuallyForm';

export default function VirtualPage() {
	return (
		<section className="flex grow flex-col">
			<AlertUsers />
			<ReplaceVirtuallyForm />
		</section>
	);
}
